import React, { useState } from 'react';
import { Alert, Button, Box, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import api from '../api';

export default function GracePeriodBanner({ subscriptionStatus, onDismiss }) {
  const [open, setOpen] = useState(true);
  const [portalLoading, setPortalLoading] = useState(false);

  if (!['past_due', 'unpaid'].includes(subscriptionStatus)) return null;

  const isPastDue = subscriptionStatus === 'past_due';

  const handleUpdatePayment = async () => {
    setPortalLoading(true);
    try {
      const res = await api.get('/api/platform/subscription/portal/');
      if (res.data?.url) window.open(res.data.url, '_blank');
    } catch (err) {
      console.error('Failed to open billing portal', err);
    } finally {
      setPortalLoading(false);
    }
  };

  return (
    <Collapse in={open}>
      <Alert
        severity={isPastDue ? 'warning' : 'error'}
        icon={<WarningAmberIcon />}
        sx={{
          borderRadius: 0,
          position: 'sticky',
          top: 0,
          zIndex: 1300,
          '& .MuiAlert-message': { display: 'flex', alignItems: 'center', gap: 2, width: '100%', flexWrap: 'wrap' }
        }}
        action={
          <IconButton size="small" onClick={() => { setOpen(false); onDismiss?.(); }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Box sx={{ flexGrow: 1 }}>
          {isPastDue
            ? '⚠️ Your subscription payment failed. Update your payment method to avoid losing access.'
            : '🚫 Your subscription is unpaid. Restore access by updating your payment method.'}
        </Box>
        <Button
          size="small"
          variant="contained"
          color={isPastDue ? 'warning' : 'error'}
          onClick={handleUpdatePayment}
          disabled={portalLoading}
          sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}
        >
          Update Payment Method
        </Button>
      </Alert>
    </Collapse>
  );
}
